import { Client, Account, Databases, Storage, Avatars, Functions } from "appwrite";

export const appwriteConfig = {
  url: import.meta.env.VITE_APPWRITE_URL,
  projectId: import.meta.env.VITE_APPWRITE_PROJECT_ID,
  databaseId: import.meta.env.VITE_APPWRITE_DATABASE_ID,
  storageId: import.meta.env.VITE_APPWRITE_STORAGE_ID,
  userCollectionId: import.meta.env.VITE_APPWRITE_USER_COLLECTION_ID,
  postCollectionId: import.meta.env.VITE_APPWRITE_POST_COLLECTION_ID,
  savesCollectionId: import.meta.env.VITE_APPWRITE_SAVES_COLLECTION_ID,
  messagesCollectionId: import.meta.env.VITE_APPWRITE_MESSAGE_COLLECTION_ID,
  notificationsCollectionId: import.meta.env.VITE_APPWRITE_NOTIFICATIONS_COLLECTION_ID,
  escrowCollectionId: import.meta.env.VITE_APPWRITE_ESCROW_COLLECTION_ID,
  dealStage: import.meta.env.VITE_APPWRITE_DEALSTAGE_COLLECTION_ID,
  products: import.meta.env.VITE_APPWRITE_PRODUCTS_COLLECTION_ID,
  liveStreams: import.meta.env.VITE_APPWRITE_LIVE_STREAMS_COLLECTION_ID,
  liveStreamsChat: import.meta.env.VITE_APPWRITE_LIVE_STREAMS_CHATS_COLLECTION_ID,
  streamPurchases: import.meta.env.VITE_APPWRITE_STREAM_PURCHASES_COLLECTION_ID,
  followsCollectionId: import.meta.env.VITE_APPWRITE_FOLLOWS_COLLECTION_ID,
  scheduledLivesCollectionId: import.meta.env.VITE_APPWRITE_SCHEDULED_LIVES_COLLECTION,
  userViolationsCollectionId: import.meta.env.VITE_APPWRITE_USER_VIOLATIONS_COLLECTION,
  trustScoreCollectionId: import.meta.env.VITE_APPWRITE_TRUST_SCORE_COLLECTION,
  trustScoreEventsCollectionId: import.meta.env.VITE_APPWRITE_TRUST_SCORE_EVENT_COLLECTION,
  ratingsCollectionId: import.meta.env.VITE_APPWRITE_RATINGS_COLLECTION,
  referralCodesCollectionId: import.meta.env.VITE_REFERRAL_CODES_COLLECTION,
  transactionsCollectionId: import.meta.env.VITE_TRANSACTIONS_TRUSTSCORE_COLLECTION,
  cashfreeCreateOrder: import.meta.env.VITE_APPWRITE_CASHFREE_CREATE_ORDER_FUNCTION_ID,
  cashfreeVerifyPayment: import.meta.env.VITE_APPWRITE_CASHFREE_VERIFY_PAYMENT_FUNCTION_ID,
  cashfreeReleasePayment: import.meta.env.VITE_APPWRITE_CASHFREE_RELEASE_PAYMENT_FUNCTION_ID,
  cashfreeWebhook: import.meta.env.VITE_APPWRITE_CASHFREE_WEBHOOK_FUNCTION_ID,
  generateAgoraTokenFunctionId : import.meta.env.VITE_APPWRITE_RAZORPAY_GENERATE_TOKEN_FUNCTION_ID,
  realtimeUpdates: true,
  createKYCSessionFunctionId: import.meta.env.VITE_APPWRITE_CREATE_KYC_SESSION_FUNCTION_ID, 
  verifyKYCFunctionId: import.meta.env.VITE_APPWRITE_VERIFY_KYC_FUNCTION_ID, 
  checkExistingUser: import.meta.env.VITE_APPWRITE_CHECK_EXISTING_USER_FUNCTION_ID, 
  checkKYCStatusFunctionId: import.meta.env.VITE_APPWRITE_CHECK_KYC_STATUS_FUNCTION_ID, 
  trackViewerFunctionId: import.meta.env.VITE_APPWRITE_TRACK_VIEWER_FUNCTION_ID,
  kycRecordsCollectionId: import.meta.env.VITE_APPWRITE_KYC_RECORDS_COLLECTION_ID, 
  kycSessionsCollectionId: import.meta.env.VITE_APPWRITE_KYC_SESSIONS_COLLECTION_ID, 
  userGuideArtice: import.meta.env.VITE_APPWRITE_USER_GUIDE_ARTICLE_COLLECTION_ID,
  userGuideCategories: import.meta.env.VITE_APPWRITE_USER_GUIDE_CATEGORIES_COLLECTION_ID,
  razorpayEndpointCall: import.meta.env.VITE_APPWRITE_RAZORPAY_ENDPOINT_CALL_ID,
  videosCollectionId: import.meta.env.VITE_APPWRITE_VIDEO_COLLECTION_ID,
  videoStatsCollectionId: import.meta.env.VITE_APPWRITE_VIDEO_STATS_COLLECTION_ID, 
  videoInteractionsCollectionId: import.meta.env.VITE_APPWRITE_VIDEO_INTERACTIONS_COLLECTION_ID,
  videoTipsCollectionId: import.meta.env.VITE_APPWRITE_VIDEO_TIPS_COLLECTION_ID,
  videoReportsCollectionId: import.meta.env.VITE_APPWRITE_VIDEO_REPORTS_COLLECTION_ID, 
  videoBucketId: import.meta.env.VITE_APPWRITE_VIDEO__BUCKET_ID, 
};

export const client = new Client();

client.setEndpoint(appwriteConfig.url);
client.setProject(appwriteConfig.projectId);

export const account = new Account(client);
export const databases = new Databases(client);
export const storage = new Storage(client);
export const avatars = new Avatars(client);
export const functions = new Functions(client);

// Helper functions for file operations
export const getFilePreview = (fileId: any) => {
  return storage.getFilePreview(appwriteConfig.storageId, fileId);
};

export const getFileView = (fileId: any) => {
  return storage.getFileView(appwriteConfig.storageId, fileId);
};

export const getFileDownload = (fileId: any) => {
  return storage.getFileDownload(appwriteConfig.storageId, fileId);
};